<template>
  <mm-tab-title v-model="tab" :titles="titles">
      <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
      <el-form ref="form" :model="result" size="small" label-width="200px">
          <div v-show="tab===1">
            <el-form-item label="Offer Month">
                <span>{{ result.offer_month }}</span>
            </el-form-item>
            <el-form-item v-if="edit" label="Offer Id">
              <mm-get-detail row_type="offer" :row_id="result.offer_id" :row_name="result.offer_id" />
            </el-form-item>
            <el-form-item label="Channel" >
              <mm-channel-select no_paused v-model="result.channel_id" style="width:100%;" />
            </el-form-item>
            <el-form-item label="Pid" required  prop="pid">
              <el-input v-model.trim="result.pid"/>
            </el-form-item>
            <el-form-item label="Cap" >
              <el-input v-model="result.cap_info"/>
            </el-form-item>
            <el-form-item label="Offer Price" prop="offer_price" required >
              <el-input type="number" @mousewheel.native.prevent v-model="result.offer_price"/>
            </el-form-item>
            <el-form-item label="Tracking Link" :style="{width: trackMaxWidth ? '100%' : '700px'}" required prop="tracking_link">
              <el-input type="textarea" rows="6" v-model="result.tracking_link" />
              <el-button @click="changeLabelWidth()">{{ trackMaxWidth ? 'Origin Width' : 'Max Width' }}</el-button>
            </el-form-item>
            <el-form-item label="Remark" style="width:700px;" prop="remark">
              <el-input type="textarea" rows="6" v-model="result.remark" />
            </el-form-item>
            <el-form-item label="Events" prop="events">
              <el-button size="medium" type="success" @click="addEvent">ADD</el-button>
              <div v-for="(item, key) in result.events" :key="key" style="padding-left: 30px;">
                <div>
                  <span style="padding-right:20px;">Event {{ key+1 }}</span>
                  <el-button size="medium" type="danger" @click="deleteEvent(key)">Delete Event {{ key+1 }}</el-button>
                </div>
                <el-form-item label="Event Name">
                  <el-input v-model.trim="item.event_name"></el-input>
                </el-form-item>
                <el-form-item label="Event Value" :prop="'event_value'+key" :rules="eventValueRules">
                  <el-input v-model.trim="item.event_value"></el-input>
                </el-form-item>
                <el-form-item label="Payout">
                  <el-input type="number" @mousewheel.native.prevent v-model="item.payout"/>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
      </el-form>

  </mm-tab-title>


</template>

<script>

export default {
props: ["edit"],
watch:{
  '$route' (to, from) {
    this.loadData();
  }
},
data() {
  return {
    result: {
      offer_id:'',
      channel_id:'',
      events: [],
      tracking_link:'',
    },
    tab: 1,
    titles:['Base Info'],
    trackMaxWidth: false,
    eventValueRules: [{
      required: true,
      validator: this.eventValueValidator
    }]
  };
},
methods: {
  eventValueValidator(rule, value, callback) {
    if (!this.result.events || this.result.events.length == 0) {
      callback();
    } else {
      let isEmpty = false;
      this.result.events.forEach((row) => {
        if (!row.event_value) {
          isEmpty = true;
        }
      })
      console.log('isEmpty',isEmpty)
      if (isEmpty) {
        callback(new Error('event_value is required'));
      } else {
        callback();
      }
    }
  },
  async submit() {
    await this.$validate(this.$refs.form);
    const request_path = this.edit?'/mmpCamp/update':'/mmpCamp/create';
    const channel = this.$cache['channel_list'].find((row) => row.value == this.result.channel_id);
    this.result.channel_name = channel && channel.name;
    const result = await this.$post(request_path,this.result);
    if(this.edit){
      this.loadData();
    }else{
      this.$router.push({ path: "/mmpCampEdit",query:{id:result._id} });
    }
          
  },
  async loadData(){
    if (this.edit) {
      const q= this.$route.query;
      this.result = await this.$post('/mmpCamp/detail',q);
      if (!this.result.events) {
        this.result.events = [];
      }
    }
  },
  changeLabelWidth() {
    this.trackMaxWidth = !this.trackMaxWidth;
  },
  addEvent() {
    this.result.events.push({
      event_name: '',
      event_value: '',
      payout: 0,
    })
  },
  deleteEvent(index) {
    this.result.events.splice(index, 1);
  },
},
  
beforeMount() {
  this.loadData();
}
};
</script>